import { ChangeEvent, FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { CRM_MAX_FIELD_LENGTH } from '../../../common/config';
import { TemplateFlexGridContainer } from '../../../components/Grid';
import { Heading } from '../../../components/Heading';
import { InputGroup } from '../../../components/InputGroup';
import { Textarea } from '../../../components/Textarea';
import { noOp } from '../../../lib/utils';
import { StepProps } from '../../../types';
import { useBriefingState } from '../BriefingState';

export const StepProblem: FC<StepProps> = ({
  mandatoryFields,
  onValidate = noOp,
}) => {
  const { t } = useTranslation();
  const [{ problem, branch }, { setProblem }] = useBriefingState();
  const dispatch = useDispatch();
  const [initialProblem] = useState(problem);

  const [isProblemValid, setIsProblemValid] = useState(true);
  const isStepValid = useMemo(() => isProblemValid, [isProblemValid]);
  useEffect(() => onValidate(isStepValid), [isStepValid, onValidate]);

  const onProblemChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    dispatch(setProblem(event.target.value));
  };

  return (
    <TemplateFlexGridContainer.BriefingStep>
      <Heading
        level="h1"
        margin={0}
        text={t(`topics:problem:heading:${branch}`)}
        optionalField={mandatoryFields['problem']?.length === 0}
      />
      <TemplateFlexGridContainer.BriefingStepBody>
        <div className="w-full md:w-8/12">
          <InputGroup label={t(`topics:problem:${branch}:name`)}>
            <div className="w-full h-full">
              <Textarea
                {...(initialProblem ? { initialValue: initialProblem } : {})}
                onChange={onProblemChange}
                rows={5}
                onValidate={setIsProblemValid}
                maxLength={CRM_MAX_FIELD_LENGTH}
              />
            </div>
          </InputGroup>
        </div>
      </TemplateFlexGridContainer.BriefingStepBody>
    </TemplateFlexGridContainer.BriefingStep>
  );
};
